import { AdminBackendPermissionNames, BackendPermissionNames, ROLE_ACTIONS } from '../Constants/Permissions'
import { Permissions } from '../Contexts/UserInfoContext'

/* PermissionsBuilder class allows to build permissions for a specific field.
 * It provides methods to add read, update, create, delete and allowed permissions.
 * The build method returns the permissions as an array of strings.
 */
export class PermissionsBuilder {
    private actions: Permissions[] = []

    constructor(private fieldName: AdminBackendPermissionNames | BackendPermissionNames) {
        this.fieldName = fieldName
    }

    read(): PermissionsBuilder {
        this.actions.push(`${this.fieldName}|${ROLE_ACTIONS.READ}` as Permissions)
        return this
    }

    update(): PermissionsBuilder {
        this.actions.push(`${this.fieldName}|${ROLE_ACTIONS.UPDATE}` as Permissions)
        return this
    }

    create(): PermissionsBuilder {
        this.actions.push(`${this.fieldName}|${ROLE_ACTIONS.CREATE}` as Permissions)
        return this
    }

    delete(): PermissionsBuilder {
        this.actions.push(`${this.fieldName}|${ROLE_ACTIONS.DELETE}` as Permissions)
        return this
    }

    allowed(): PermissionsBuilder {
        this.actions.push(`${this.fieldName}` as Permissions)
        return this
    }

    build(): Permissions[] {
        return this.actions
    }
}
